export default {
	message: "No se encontró nada aquí...",
	goHome: "Volver al inicio",
};
